<!-- //
侧边树组件，添加
@auth xuyd
@date 2024-05-01
//-->
<template>
  <el-dialog
      class="dialog-container"
      :visible.sync="visible"
      :title="opts.title"
      :modal="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      top="10vh"
      width="600px">
    <div>
      <slot :options="options" :data-list="dataList" >
        <GroupDetail ref="refGroupDetail" :options="options" :data-list="dataList" ></GroupDetail>
      </slot>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="handleOk">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>

import GroupDetail from './detail.vue';

export default {
  name: 'CompSideTreeDetailDlg',
  components: {
    GroupDetail
  },
  data() {
    return {
      visible: false,
      disabled: false,
      parentNode: null,
      opts: {
        title: '添加',
        mode: 1,
      },
    }
  },
  computed:{
    addMode() {
      return this.opts.mode === 1;
    },
    editMode() {
      return this.opts.mode === 2;
    }
  },
  props: {
    dataList: {
      type: Array,
      default: () => {
        return []
      }
    },
    options: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    showModal(opts) {
      let that = this;
      this.opts = {...opts};
      delete this.opts['onOk'];
      delete this.opts['onCancel'];
      this.disabled = false;
      this.opts.onCancel = opts.onCancel;
      this.opts.onOk = (dialogData) => {
        let promise = opts.onOk && opts.onOk(dialogData);
        if (promise) {
          promise.then(() => {
            that.hideModal();
          }).catch(err => {
            console.log(err)
          })
        } else {
          that.hideModal();
        }
      };

      this.visible = true;
      console.log("=====open========", opts)
      this.$nextTick(() => {
        this.$emit('open', opts);
      })
    },
    hideModal() {
      this.visible = false;
      this.$emit('close')
    },
    handleOk() {
      // console.log("groupList=>", this.dataList);
      new Promise(resolve => this.$emit('confirm', resolve)).then(retData => {
        this.$modal.msgSuccess('保存成功');
        this.opts.onOk(retData);
      })
    }
  }
}
</script>

<style lang="less" scoped>

</style>